import axios from "axios";

import * as c from "./../const";

export async function slider() {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.SLIDER;
    let res = await axios.get(url, options);
    return res.data;
  } catch (e) {
    console.log(e);
  }
}

export async function banner(id) {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.BANNER + "/" + id;
    let res = await axios.get(url, options);
    return res.data;
  } catch (e) {
    console.log(e);
  }
}

export async function headline() {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.HEADLINE;
    let res = await axios.get(url, options);
    return res.data;
  } catch (e) {
    console.log(e);
  }
}
export async function photographer() {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.PHOTOGRAPHER;
    let res = await axios.get(url, options);
    return res.data;
  } catch (e) {
    console.log(e);
  }
}

export async function news_with_limit(data) {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.NEW_BLOG_LIMIT + "/" + data;
    let res = await axios.get(url, options);
    return res.data;
  } catch (e) {
    console.log(e);
  }
}

export async function photographerGallery(data) {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.PHOTOGRAPHER_GALLERY + "/" + data;
    let res = await axios.get(url, options);
    return res.data;
  } catch (e) {
    console.log(e);
  }
}

export async function newsHome() {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.NEWS;
    let res = await axios.get(url, options);
    return res.data;
  } catch (e) {
    console.log(e);
  }
}

export async function news(data) {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.NEWS + "/" + data;
    let res = await axios.get(url, options);
    return res.data;
  } catch (e) {
    console.log(e);
  }
}

export async function checkPayment(data) {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.CHECK_PAYMENT + "/" + data;
    let res = await axios.get(url, options);
    return res.data;
  } catch (e) {
    console.log(e);
  }
}

export async function uploadNews(data) {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let res = await axios.post(c.NEWS, data, options);
    return res;
  } catch (e) {
    return e;
  }
}

export async function contactUsData(data) {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let res = await axios.post(c.CONTACT_US_DATA, data, options);
    return res;
  } catch (e) {
    console.log(e);
  }
}

export async function gallery() {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.GALLERY;
    let res = await axios.get(url, options);
    return res.data;
  } catch (e) {
    console.log(e);
  }
}

export async function postCount(data) {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.GET_SPONSOR_COUNT + "/" + data;
    let res = await axios.get(url, options);
    return res.data;
  } catch (e) {
    console.log(e);
  }
}

export async function aboutUs() {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.ABOUT_US;
    let res = await axios.get(url, options);
    return res.data;
  } catch (e) {
    console.log(e);
  }
}

export async function contactUs() {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.CONTACT_US;
    let res = await axios.get(url, options);
    return res.data;
  } catch (e) {
    console.log(e);
  }
}

export async function contributors() {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.CONTRIBUTORS;
    let res = await axios.get(url, options);
    return res.data;
  } catch (e) {
    console.log(e);
  }
}

export async function institute() {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.INSTITUTE;
    let res = await axios.get(url, options);
    return res.data;
  } catch (e) {
    console.log(e);
  }
}

export async function company() {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.COMPANY;
    let res = await axios.get(url, options);
    return res.data;
  } catch (e) {
    console.log(e);
  }
}

export async function searchPost(data) {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.SEARCH_POST;
    let res = await axios.post(url, data, options);
    return res.data;
  } catch (e) {
    console.log(e);
  }
}

export async function payment(data) {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.PAYMENT;
    let res = await axios.post(url, data, options);
    return res.data;
  } catch (e) {
    console.log(e);
  }
}

export async function register(data) {
  try {
    let res = await axios.post(c.REGISTER_USER, data);
    return res;
  } catch (e) {
    console.log(e);
  }
}

export async function login(data) {
  try {
    let res = await axios.post(c.LOGIN, data);
    return res;
  } catch (e) {
    console.log(e);
  }
}

export async function sponsorCompanyReg(data, id) {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.SPONSOR_COMPANY_REGISTRATION + "/" + id;
    // console.log(url)
    let res = await axios.put(url, data, options);
    return res;
  } catch (e) {
    console.log(e);
  }
}

export async function getSponsorDetails(id) {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.SPONSOR_COMPANY_REGISTRATION + "/" + id;
    let res = await axios.get(url, options);
    return res;
  } catch (e) {
    console.log(e);
  }
}

export async function subscription() {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.SUBSCRIPTION;
    let res = await axios.get(url, options);
    return res;
  } catch (e) {
    console.log(e);
  }
}

export async function featuresInDepth() {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.FEATURES_IN_DEPTH;
    let res = await axios.get(url, options);
    return res;
  } catch (e) {
    console.log(e);
  }
}

export async function sponsor() {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.SPONSOR;
    let res = await axios.get(url, options);
    return res;
  } catch (e) {
    console.log(e);
  }
}

export async function type() {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.TYPE;
    let res = await axios.get(url, options);
    return res;
  } catch (e) {
    console.log(e);
  }
}

export async function category() {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.CATEGORY;
    let res = await axios.get(url, options);
    return res;
  } catch (e) {
    console.log(e);
  }
}

export async function sponsorPost(id) {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let url = c.SPONSOR_POST + id;
    let res = await axios.get(url, options);
    return res;
  } catch (e) {
    console.log(e);
  }
}

// ? USER COMMENTS

export async function user_comments(data) {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    let res = await axios.post(c.USER_COMMENT, data, options);
    return res;
  } catch (e) {
    return e;
  }
}

// ? USER COMMENTS
export const user_comments_get_byid = async (data) => {
  try {
    const options = {
      headers: {
        authorization: "ABCDEFGHIJK",
        Accept: "application/json",
      },
    };
    const url = c.USER_COMMENT + "/" + data.news_id;
    console.log(url);
    const res = await axios.get(url, options, data);
    return res;
  } catch (e) {
    return e.response;
  }
};

// try {
//     const options = {
//         headers: {
//             Accept: "application/json",
//             "Content-Type": "multipart/form-data"
//         }
//     };
//     const url = `${c.CHECK_USER_EXISTS}` + '?userName=' + userName;

//     const form_data = new FormData();
//     for (let key in data)
//         form_data.append(key, data[key]);

//     let res = await axios.get(url, form_data, options);

//     return res.data;
// } catch (e) {

//     throw handler(e);
// }

// export async function createUser(data) {
//     try {
//         let res = await axios.post(c.CREATE_USER, data);

//         return res;
//     } catch (e) {
//         throw handler(e)
//     }
// }
